import React from 'react';
import './credit-card.css';

class CreditCard extends React.Component {

    constructor(props) {
        super(props);
        this.numberCharacter = '•';
        this.updateCreditCardInfo = this.props.updateCreditCardInfo;
        this.defaultFormat = /(\d{1,4})/g;

        this.cards = [
            {
                type: 'amex',
                pattern: /^3[47]/,
                format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
                length: [15],
                cvcLength: [4],
                luhn: true
            }, {
                type: 'dankort',
                pattern: /^5019/,
                format: this.defaultFormat,
                length: [16],
                cvcLength: [3],
                luhn: true
            }, {
                type: 'dinersclub',
                pattern: /^(36|38|30[0-5])/,
                format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
                length: [14],
                cvcLength: [3],
                luhn: true
            }, {
                type: 'discover',
                pattern: /^(6011|65|64[4-9]|622)/,
                format: this.defaultFormat,
                length: [16],
                cvcLength: [3],
                luhn: true
            }, {
                type: 'jcb',
                pattern: /^35/,
                format: this.defaultFormat,
                length: [16],
                cvcLength: [3],
                luhn: true
            }, {
                type: 'laser',
                pattern: /^(6706|6771|6709)/,
                format: this.defaultFormat,
                length: [16, 17, 18, 19],
                cvcLength: [3],
                luhn: true
            }, {
                type: 'maestro',
                pattern: /^(5018|5020|5038|6304|6703|6708|6759|676[1-3])/,
                format: this.defaultFormat,
                length: [12, 13, 14, 15, 16, 17, 18, 19],
                cvcLength: [3],
                luhn: true
            }, {
                type: 'mastercard',
                pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
                format: this.defaultFormat,
                length: [16],
                cvcLength: [3],
                luhn: true
            }, {
                type: 'unionpay',
                pattern: /^62/,
                format: this.defaultFormat,
                length: [16, 17, 18, 19],
                cvcLength: [3],
                luhn: false
            }, {
                type: 'visaelectron',
                pattern: /^4(026|17500|405|508|844|91[37])/,
                format: this.defaultFormat,
                length: [16],
                cvcLength: [3],
                luhn: true
            }, {
                type: 'elo',
                pattern: /^(4011|438935|45(1416|76|7393)|50(4175|6699|67|90[4-7])|63(6297|6368))/,
                format: this.defaultFormat,
                length: [16],
                cvcLength: [3],
                luhn: true
            }, {
                type: 'visa',
                pattern: /^4/,
                format: this.defaultFormat,
                length: [13, 16, 19],
                cvcLength: [3],
                luhn: true
            }
        ];

        this.allowedCreditCardTypes = this.props.allowedCreditCardTypes || this.cards.map(card => card.type);

        this.unknownCreditCardType = 'rea-cc-unknown';
        this.state = {
            cvc: this.props.cvc || '',
            expiry: this.props.expiry || 'MM/YYYY',
            focused: this.props.focused || null,
            name: this.props.name || 'CARD HOLDER NAME',
            number: this.props.creditCardNumber || '•••• •••• •••• ••••',
            creditCardType: this.unknownCreditCardType,
            issuer: ''
        }
    }

    render = () => {
        return (
            <div className="rea-block-row rea-cc-container">
                <div className="rea-block-6 rea-cc-display rea-mobile-padding-0">
                    <div
                        className={['rea-block-row', this.state.creditCardType, 'rea-cc-elements', (this.state.focused === 'cvc' && this.state.issuer !== 'amex') ? 'rea-cc-flipped' : ''].join(' ').trim()}>
                        <div className="rea-block-12 rea-cc-front">
                            <div className="rea-cc-background"></div>
                            <div className="rea-cc-issuer">
                                <i className={[this.state.issuer !== '' ? 'fa fa-cc-' + this.state.issuer : ''].join(' ').trim()}></i>
                            </div>
                            {this.state.issuer === 'amex' &&
                            <div
                                className={['rea-cc-cvc-front', this.state.focused === 'cvc' ? 'rea-cc-elements-focused' : ''].join(' ').trim()}>{this.getCvc()}</div>
                            }
                            <div
                                className={['rea-cc-number', this.state.focused === 'number' ? 'rea-cc-elements-focused' : ''].join(' ').trim()}>{this.getNumber()}</div>
                            <div className="rea-cc-expiry">
                                <div className="rea-cc-valid-thru">valid<br/>thru</div>
                                <div
                                    className={['rea-cc-expiry-valid', this.state.focused === 'expirationDate' ? 'rea-cc-elements-focused' : ''].join(' ').trim()}>{this.getExpiry()}</div>
                            </div>
                            <div
                                className={['rea-cc-name', this.state.focused === 'name' ? 'rea-cc-elements-focused' : ''].join(' ').trim()}>{this.getName()}</div>
                            <div className="rea-cc-chip">
                                <img src="/images/home-based/websites/cc-chip.png" alt=""/>
                            </div>
                        </div>
                        <div className="rea-block-12 rea-cc-back">
                            <div className="rea-cc-background"></div>
                            <div className="rea-cc-stripe"></div>
                            <div className="rea-cc-signature"></div>
                            <div className="rea-cc-cvc">{this.getCvc()}</div>
                            <div className="rea-cvc-back"></div>
                            <div className="rea-cc-issuer">
                                <i className={[this.state.issuer !== '' ? 'fa fa-cc-' + this.state.issuer : ''].join(' ').trim()}></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentDidUpdate = (previousProps) => {
        if (previousProps.number !== this.props.number) {
            let number = this.formatCardNumber(this.props.number);
            this.setState({number: number});
            this.updateCreditCardType(this.props.number);
            if (typeof this.updateCreditCardInfo === 'function') {
                this.updateCreditCardInfo(this.getCardFromNumber(this.props.number), this.validateCardNumber(this.props.number));
            }
        }

        if (previousProps.name !== this.props.name) {
            this.setState({name: this.props.name || 'CARD HOLDER NAME'});
        }

        if (previousProps.expiry !== this.props.expiry) {
            this.setState({expiry: this.props.expiry || 'MM/YY'});
        }

        if (previousProps.cvc !== this.props.cvc) {
            this.setState({cvc: this.props.cvc || ''});
        }

        if (previousProps.focused !== this.props.focused) {
            this.setState({focused: this.props.focused || null});
        }
    }

    getNumber = () => {
        return this.state.number;
    }

    getName = () => {
        return this.state.name;
    }

    getExpiry = () => {
        return this.state.expiry;
    }

    getCvc = () => {
        return this.state.cvc;
    }

    getNumberMaxLength = () => {
        return 16;
    }

    updateCreditCardType = (num) => {
        let card = this.getCardFromNumber(num);
        if (card !== null) {
            this.setState({creditCardType: 'cc-' + card.type});
            this.setState({issuer: card.type});
        } else {
            this.setState({creditCardType: this.unknownCreditCardType});
            this.setState({issuer: ''});
        }
    }

    getCardFromNumber = function (num) {
        let cardType = null;
        this.cards.forEach(card => {
            if (card.pattern.test(num)) {
                cardType = card;
                return;
            }
        });
        return cardType;
    };

    validateCardNumber(num) {
        let card;
        //num = (num + '').replace(/\s+|-/g, '');
        if (!/^\d+$/.test(num)) {
            return {valid: false, allowed: false};
        }
        card = this.getCardFromNumber(num);
        if (!card) {
            return {valid: false, allowed: false};
        }
        return ({
            valid: (card.length.indexOf(num.length) >= 0 && (card.luhn === false || this.luhnCheck(num))),
            allowed: this.allowedCreditCardTypes.indexOf(card.type) > -1
        });
    };

    luhnCheck(num) {
        let digit, digits, j, len, odd, sum;
        odd = true;
        sum = 0;
        digits = (num + '').split('').reverse();
        for (j = 0, len = digits.length; j < len; j++) {
            digit = digits[j];
            digit = parseInt(digit, 10);
            if ((odd = !odd)) {
                digit *= 2;
            }
            if (digit > 9) {
                digit -= 9;
            }
            sum += digit;
        }
        return sum % 10 === 0;
    };

    formatCardNumber(num) {
        let card, groups, ref, upperLength;
        card = this.getCardFromNumber(num);
        if (!card) {
            return num;
        }
        upperLength = card.length[card.length.length - 1];
        num = num.replace(/\D/g, '');
        num = num.slice(0, upperLength);
        if (card.format.global) {
            return (ref = num.match(card.format)) != null ? ref.join(' ') : void 0;
        } else {
            groups = card.format.exec(num);
            if (groups == null) {
                return;
            }
            groups.shift();
            groups = groups.filter(function (n) {
                return n;
            });
            return groups.join(' ');
        }
    }

}

export default CreditCard;
